import { AnimatePresence, motion } from 'framer-motion';
import { t } from 'i18next';
import { useEffect } from 'react';
import styled from 'styled-components';

const AlertDialog = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

const DialogContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  color: white;
  font-weight: 800;
  font-size: 26px;
  line-height: 31px;
  text-align: center;
  margin-bottom: 10px;
`;

const Description = styled.div`
  color: white;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 7px;
  white-space: pre-line;
`

export const FollowedDialog = ({ isAlertOpen, setIsAlertOpen, isFollowed=false, onClosed }) => {
  const handleClose = () => {
    setTimeout(() => {
      setIsAlertOpen(false);
      onClosed();
    }, 2000);
  };

  useEffect(() => {
    handleClose();
  }, []);

  return (
    <AnimatePresence>
      {isAlertOpen && (
        <AlertDialog
          onClick={() => {
            setIsAlertOpen(false);
            onClosed();
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <DialogContent
            onClick={(e) => e.stopPropagation()}
            initial={{ y: -50, scale: 0.95 }}
            animate={{ y: 0, scale: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
          >

            {isFollowed ? (
              <>
                <img src="/assets/icons/fan-buddy/purple_fanheart.png" alt="Purple Fanheart" className="w-[180px] h-[180px]" />
                <Title>{t('FollowedDialog.matchedTitle')}</Title>
                <Description>{t('FollowedDialog.matchedDescription')}</Description>
              </>
            ) : (
              <>
                <img src="/assets/icons/fan-buddy/WavingHand.png" alt="Waving Hand" className="w-[180px] h-[180px]" />
                <Title>{t('FollowedDialog.title')}</Title>
                <Description>{t('FollowedDialog.description')}</Description>
              </>
            )}
          </DialogContent>
        </AlertDialog>
      )}
    </AnimatePresence>
  );
}
